// @flow

import { isServerError } from '../utils/Utils';
import type { IDNumber, ToastType, ServerError } from '../common/typings';

export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';

export function addToast(
  message: string,
  type: ToastType = 'success',
  displayTime: number = 0,
  includeTimer: boolean = false
) {
  return {
    type: ADD_TOAST,
    payload: {
      message,
      type,
      displayTime,
      includeTimer
    }
  };
}

export function removeToast(id: IDNumber) {
  return {
    type: REMOVE_TOAST,
    payload: {
      id
    }
  };
}

export function addSuccessToast(message: string) {
  return {
    type: ADD_TOAST,
    payload: {
      message,
      type: 'success'
    }
  };
}

export function addErrorToast(
  error: Error | ServerError | Object | string | Array<string>,
  displayTime: number = 0,
  includeTimer: boolean = false
) {
  let message;
  if (isServerError(error)) {
    const serverError = ((error: any): ServerError);
    message = serverError.response.message || 'Unknown server error';
  } else if (typeof error === 'string') {
    message = error;
  } else if (typeof error === 'object' && error.message) {
    message = error.message;
  } else if (Array.isArray(error) && error.every(e => typeof e === 'string')) {
    message = error;
  } else {
    message = 'Unknown error';
  }

  return {
    type: ADD_TOAST,
    payload: {
      message,
      type: 'error',
      displayTime,
      includeTimer
    }
  };
}

export function requestFailure(error: Error) {
  return {
    type: REQUEST_FAILURE,
    payload: {
      error
    }
  };
}
